/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_TitleInputs */

const ja_home_agency_title = /** @type {(inputs: Home_Agency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN, SERVICES TO PRODUCE GAME CULTURE`)
};

const en_home_agency_title = /** @type {(inputs: Home_Agency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN, SERVICES TO PRODUCE GAME CULTURE`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN, SERVICES TO PRODUCE GAME CULTURE" |
*
* @param {Home_Agency_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_agency_title = /** @type {((inputs?: Home_Agency_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_title(inputs)
	return en_home_agency_title(inputs)
});